<template>
  <div class="cycle-chart-container">
    <DeltaT
      :graphData="graphData"
    />
    <SensorData
      :graphData="graphData"
    />
    <Humidity
      v-if="sensorCheck"
      :graphData="graphData"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DeltaT from './cycleGraph/DeltaT.vue';
import SensorData from './cycleGraph/SensorData.vue';
import Humidity from './cycleGraph/Humidity.vue';

export default {
  name: 'CycleGraph',
  components: {
    DeltaT,
    SensorData,
    Humidity,
  },
  props: {
    graphData: Array,
  },
  computed: {
    ...mapState({
      sensors: state => state.customerDetail.sensors,
    }),
    sensorCheck() {
      return this.sensors.find(s => s.sensorType === 'A2TempHumidity' || s.sensorType === 'A2RoomTempHumidity');
    },
  },
};
</script>

<style lang="scss" scoped>
.delta-chart {
  margin-bottom: 16px;
  width: 100%;
  max-width: 1705px;
}
.humid-chart {
  margin-top: 16px;
  width: 100%;
  max-width: 1705px;
}
</style>
